/**
 * Created by Administrador on 3/31/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('legends', {
                parent: 'app',
                url: '/legends?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/legend/legend/legends.html',
                        controller: 'legendsController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['legend', 'structureSeatMap']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLegend('legends')
                            }],
                            legends: ['legendService', '$stateParams', function (legendService, $stateParams) {
                                return legendService.getLegendsPage($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            });
    }
})();
